import { connect } from 'react-redux';
import ContactView from './index'
import {contactAction} from '../../actions/Contact'
import {parse} from 'querystringify';
import moment from 'moment'
const mapStateToProps = (state, props) => {    
    return {

    }
}

const mapDispatchToProps = (dispatch, state) => { 
    return {
	contactAction: (contact) => dispatch(contactAction(contact))
    }
}

const ContactContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactView);




export default ContactContainer;



// WEBPACK FOOTER //
// ./src/components/Contact/Container.js